<template>
  <div>
    <div class="row">
      <div class="col-12 pl-0">
        <span class="float-right mt-2">
          <button class="btn btn-xs btn-dark font-weight-bold e-text-white" type="button" @click="redirectToAuditorList">
            <font-awesome-icon icon="chevron-left" class="e-text-black"/> Go Back
          </button>
        </span>
        <h3 class="text-left ml-3">Auditor Profile</h3>
        <div class="card p-3 shadow-sm">
          <div class="row align-items-center">
            <div class="col-lg-2 align-self-start">
              <div class="card">
                <div class="card-body text-center p-1">
                  <ImageCapture v-if="toImgCapture" @cancel-photo="cancelPhoto" @photo-saved="handlePhotoSaved"/>
                  <template v-else>
                    <ImageUpload
                      ref="image-upload-component"
                      :visibility="false"
                      :trigger-upload-button="true"
                      :image-height="'230.5px'"
                      @cancel-photo="cancelPhoto"
                      @photo-saved="handlePhotoSaved"
                      @handle-file-change="toImgUpload = true"
                    />
                    <div v-if="!toImgUpload">
                      <div :style="{ backgroundImage: 'url(' + auditorPic + ')', minWidth: '100%', height: '230.5px' }" class="background-contain">
                      </div>
                      <div v-if="isAllowed('audit-team.auditors.photo.edit')">
                        <button class="btn btn-sm btn-primary m-1"
                                @click.prevent="toImgCapture = !toImgCapture">
                          Capture
                        </button>
                        <button class="btn btn-sm btn-success m-1"
                                @click.prevent="$refs['image-upload-component'].clickUploadButton()">
                          Upload
                        </button>
                        <button class="btn btn-sm btn-secondary m-1"
                                @click.prevent="resetPhoto()">
                          Reset
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="col-lg-10 p-lg-0 align-self-start">
              <div class="col-12">
                <tab-group
                  :routes="routes"
                />
              </div>
              <router-view/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLoading from "@/components/elements/AppLoading";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";
import {permissionMixin} from "@/mixins/permissionMixins";
import MultiSelectCustom from "@/components/MultiSelectCustom.vue";
import AuditorMixin from "@/mixins/AuditorMixin";
import DateMixin from "@/mixins/DateMixin";
import ImageCapture from "@/components/common/avatar/ImageCapture.vue";
import ImageUpload from "@/components/common/avatar/ImageUpload.vue";
// import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import AuditorGeneralInfo from "@/components/modules/ia/auditor/AuditorGeneralInfo.vue";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import TabGroup from "@/components/common/TabGroup.vue";

export default {
  name: "AuditorProfile",
  mixins:[permissionMixin, DateMixin, AuditorMixin, vueAppMixin],
  data () {
    return {
      staffIcon: require('@/assets/staff_icon.png'),
      auditorPic : require('@/assets/staff_icon.png'),
      loading: false,
      auditorEditedData : null,
      toEdit: false,
      toImgUpload: false,
      toImgCapture: false,
      showCertificateField : false,
      certificatesToDelete : [],
      signatureImageSrc : null,
      croppedSignature : false,
      // routes: [
      //   {
      //     name: 'AuditorGeneralInfo',
      //     text: 'General',
      //   },
      //   {
      //     name: 'AuditorAuditHistory',
      //     text: 'Audit History',
      //   },
      // ],
    }
  },

  methods: {
    ...mapActions(['getMngmtOfficeKeys', 'getAuditorData', 'getAuditorList', 'deleteAuditorCertificate', 'updateAuditor']),
    redirectToAuditorList() {
      return this.$router.push({name: 'AuditorList'});
    },
    cancelPhoto() {
      this.toImgCapture = false
      this.toImgUpload = false
    },
    async convertToBlob(imageSrc) {
      return fetch(imageSrc)
        .then((res) => res.blob())
        .then((blob) => {
          return blob;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    async resetPhoto() {
      const captureImageToBlob = await this.convertToBlob(this.staffIcon);
      const newImage = new File([captureImageToBlob], 'image.png', { type: 'image/png' });
      let formData = new FormData();
      formData.append('profile_photo', newImage)

      formData.append('is_active', this.auditorEditedData.is_active ? 1 : 0);

      let updateResponse = await this.updateAuditor({
        id : this.auditorEditedData.id,
        formData : formData
      });
      if (updateResponse.result === false) {
        return AlertService.errorAlert(updateResponse.message, 'RESETTING OF AUDITOR PROFILE PIC');
      }
      this.auditorPic = this.staffIcon;
      AlertService.successAlert(updateResponse.message, 'RESETTING OF AUDITOR PROFILE PIC');
    },


    async handlePhotoSaved(data) {
      this.toImgCapture = false
      this.toImgUpload = false
      this.auditorPic = data.url;
      let formData = new FormData();
      formData.append('profile_photo', data.file)

      formData.append('is_active', this.auditorEditedData.is_active ? 1 : 0);

      let updateResponse = await this.updateAuditor({
        id : this.auditorEditedData.id,
        formData : formData
      });

      if (updateResponse.result === false) {
        return AlertService.errorAlert(updateResponse.message, 'UPDATING OF AUDITOR PROFILE PIC');
      }

      AlertService.successAlert(updateResponse.message, 'UPDATING OF AUDITOR PROFILE PIC');
    },
  },

  components: {
    TabGroup,
    AuditorGeneralInfo,
    ImageUpload,
    ImageCapture,
    MultiSelectCustom,
    'loading': AppLoading,
    Cropper : () => import('vue-advanced-cropper')
  },
  computed: {
    ...mapGetters(['mngmntOfficeKeys', 'auditorData', 'leadAuditors', 'nonLeadAuditors']),
    routes() {
      const routes = [
        {
          name: 'AuditorGeneralInfo',
          text: 'General',
        },
        {
          name: 'AuditorAuditHistory',
          text: 'Audit History',
        },
      ];

      if (this.auditorData?.is_designated_person === 1) {
        routes.push({
          name: 'AuditorDesignatedPersonCertificateInfo',
          text: 'DP Certificates',
        });
      }

      return routes;
    }
  },
  mounted() {
    $('#main_content').css({
      marginLeft: '15px',
      marginRight: '10px'
    });
  },

  async created() {
    await this.getAuditorData({
      auditor_id : this.$route.params.id
    });
    this.auditorEditedData = Object.assign({}, this.auditorData);

    await this.getMngmtOfficeKeys();

    if (this.auditorData.profile_photo_url !== null) {
      this.auditorPic = this.auditorData.profile_photo_url;
    }

  },
}
</script>

<style scoped lang="scss">
.nav > li {
  margin: .5rem 0;
  padding: .5rem;
  border-radius: 5px;
  &:hover, &:hover * {
    background-color: white;
    color: #d3313c;
  }
}
.e-btn-grp > li {
  list-style: none;
  font-size: 13px;
  padding: 4px;
  border-radius: 3px;
  color: #d3313c;
  cursor: pointer;
  &:hover {
    background-color: #fbeaec;
  }

  * {
    color: #d3313c;
  }
}
table tbody td {
  vertical-align: middle !important;
}

table tbody td label {
  margin-bottom: 0 !important;
}
#ModelNav {
  padding: 0;
  li > a {
    padding: .5rem 1rem;
    color: #435464;
  }
  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }
}
.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
  * {
    color: #d3313c;
  }
}

.active{
  background-color: #dc3545 !important;
}
</style>
